import React, { useState, useEffect } from "react";
import moment from "moment";

const DigitalClock = () => {
  const [currentTime, setCurrentTime] = useState(moment());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Define constants for readability
  // const day = currentTime.format("ddd");
  const date = currentTime.format("D MMM");
  const time = currentTime.format("h:mm A");

  return (
    <small className="flex justify-start items-center w-full text-zinc-400/80">
      {date} {time}
    </small>
  );
};

export default DigitalClock;
